<template>
  <div class="lock-page login-bg overflow-hidden">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page d-flex flex-column">
      <div id="particles-js"></div>
      <img
        src="static/img/central-gym150x150.webp"
        class="mx-auto mb-1 over logo"
        style="width: 150px"
        alt="CentralGym logo"
      />
      <card type="login" class="mb-1 over login-card mx-auto">
        <div class="text-center">
          <h3 class="header text-center mb-4">Sesión Bloqueada</h3>
          <div class="user-info mb-4">
            <h4 class="text-primary mb-1">{{ this.username }}</h4>
            <h6 class="text-muted">{{ this.email }}</h6>
          </div>
          <fg-input
            type="password"
            placeholder="Ingresa tu contraseña para continuar..."
            v-model="form.password"
            addon-left-icon="nc-icon nc-key-25"
          />
          <p-button
            @click="unLock"
            type="success"
            round
            block
            class="mb-3 mx-auto w-75"
            :disabled="!form.password || !isComponentReady"
          >
            <i class="nc-icon nc-lock-circle-open"></i>
            Desbloquear
          </p-button>
          <p class="text-center text-muted small mb-0">
            Ingresa tu contraseña para continuar con tu sesión
          </p>
        </div>
      </card>
      <div class="full-page">
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import { Card, Button, FgInput } from "src/components/UIComponents";
import axios from "axios";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    FgInput,
    [Button.name]: Button,
  },
  methods: {
    showSwal(mensajeServicio, CodigoHTTP) {
      this.$swal.fire({
        title: `ERROR: ${CodigoHTTP}`,
        text: mensajeServicio,
        icon: "error",
        confirmButtonColor: "#6bd098",
      });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    unLock() {
      if (!this.isComponentReady) {
        return;
      }
      
      if (!this.form.password) {
        this.$swal.fire({
          title: "Contraseña requerida",
          text: "Por favor ingresa tu contraseña",
          icon: "warning",
          confirmButtonColor: "#6bd098",
        });
        return;
      }

      this.$swal.fire({
        title: "Desbloqueando...",
        text: "Verificando credenciales",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      this.$axiosLogin
        .post(this.$Operations.Login, {
          Header: {
            Operacion: this.$Operations.Login,
          },
          Body: {
            idAplicacion: this.$store.getters.getAPPId,
            usuarioSesion: this.username,
            password: this.form.password,
          },
        })
        .then((result) => {
          let response = result.data.Response;
          if (
            response.Resultado.CodigoHTTP === 200 ||
            response.Resultado.CodigoHTTP === 201
          ) {
            sessionStorage.removeItem("isLocked");
            this.$swal.fire({
              title: "¡Sesión desbloqueada!",
              text: "Redirigiendo al dashboard...",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              this.$router.push("/");
            });
          } else {
            this.showSwal(
              response.Resultado.MensajeServicio || "Error de autenticación",
              response.Resultado.CodigoHTTP
            );
          }
        })
        .catch((err) => {
          let mensajeServicio = "Error inesperado";
          let CodigoHTTP = "ERROR";
          
          if (err.response && err.response.data && err.response.data.Response) {
            mensajeServicio = err.response.data.Response.Resultado.MensajeServicio;
            CodigoHTTP = err.response.data.Response.Resultado.CodigoHTTP;
          } else {
            mensajeServicio = err.message || "Error de conexión";
          }
          
          this.showSwal(mensajeServicio, CodigoHTTP);
        })
        .finally(() => {
          // Asegurar que el modal de loading se cierre siempre
          setTimeout(() => {
            this.$swal.close();
          }, 100);
        });
    },
    
    aggressiveModalCleanup() {
      // Cerrar SweetAlert de todas las formas posibles
      try {
        if (window.Swal) {
          window.Swal.close();
        }
        if (this.$swal) {
          this.$swal.close();
        }
      } catch (e) {
        // Ignorar errores al cerrar SweetAlert
      }
      
      // Eliminar cualquier overlay de SweetAlert del DOM
      try {
        const swalContainers = document.querySelectorAll('.swal2-container');
        swalContainers.forEach(container => {
          container.remove();
        });
        
        const swalOverlays = document.querySelectorAll('.swal2-backdrop-show');
        swalOverlays.forEach(overlay => {
          overlay.remove();
        });
        
        // Eliminar clases de SweetAlert del body
        document.body.classList.remove('swal2-shown', 'swal2-backdrop-show');
        
      } catch (e) {
        // Ignorar errores al limpiar DOM
      }
    },
    
    initParticles() {
      particlesJS("particles-js", {
        particles: {
          number: { value: 80, density: { enable: true, value_area: 800 } },
          color: { value: "#ffffff" },
          shape: { type: "circle" },
          opacity: { value: 0.3, random: true },
          size: { value: 3, random: true },
          move: {
            enable: true,
            speed: 0.8,
            direction: "none",
            random: true,
            out_mode: "out",
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "repulse" },
            onclick: { enable: true, mode: "push" },
          },
          modes: {
            repulse: { distance: 80, duration: 0.4 },
            push: { particles_nb: 3 },
          },
        },
      });
    },
  },
  data() {
    return {
      form: {
        password: "",
      },
      username: sessionStorage.getItem("WHbUjdv3TG") || "Usuario",
      email: sessionStorage.getItem("email") || "sin@email.com",
      isComponentReady: false,
    };
  },
  beforeCreate() {
    sessionStorage.setItem("isLocked", true);
    // Intentar cerrar cualquier modal que pueda estar abierto
    try {
      if (window.Swal) {
        window.Swal.close();
      }
    } catch (e) {
      // Ignorar errores al cerrar SweetAlert
    }
  },
  mounted() {
    // Cerrar cualquier modal de SweetAlert que pueda estar abierto
    try {
      if (window.Swal) {
        window.Swal.close();
      }
      if (this.$swal) {
        this.$swal.close();
      }
    } catch (e) {
      // Ignorar errores al cerrar SweetAlert
    }
    
    this.initParticles();
    
    // Limpieza agresiva de cualquier overlay o modal del DOM
    setTimeout(() => {
      this.aggressiveModalCleanup();
      this.isComponentReady = true;
    }, 500);
  },
  beforeDestroy() {
    // Limpiar cualquier modal de SweetAlert antes de destruir el componente
    this.aggressiveModalCleanup();
    this.closeMenu();
  },
};
</script>
<style>
.login-bg {
  background-color: #001a00;
}

.over {
  z-index: 6;
}

.logo {
  margin-top: 100px;
}

.login-card {
  width: 400px;
  max-width: 90%;
}

.user-info {
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}

#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
}

/* Responsive */
@media (max-width: 768px) {
  .logo {
    margin-top: 50px;
  }
  
  .login-card {
    width: 350px;
  }
}

@media (max-width: 480px) {
  .login-card {
    width: 300px;
  }
}
</style>
